import {
  BatchUpdateVatPayload,
  OfferOverrides,
  OfferWithSelectionAndAuthor,
  OfferingApiBatchUpdateOverridesPayload,
  OfferingApiUpdateOffersPayload,
  OfferingPlatformScope,
  SelectionOverridesResponse,
} from 'modules/shared-menu/types';

import { Offer } from '../../../types';

type BuildBatchEnableDisableOfferPayloadsArgs = {
  enabled: boolean;
  offers: Offer[];
  selectionId: string;
  userId: string;
};

export const buildBatchEnableDisableOfferPayloads = ({
  enabled,
  offers,
  selectionId,
  userId,
}: BuildBatchEnableDisableOfferPayloadsArgs): OfferWithSelectionAndAuthor[] => {
  return offers.map(offer => {
    const { scope, ...offerWithoutScope } = offer;

    return {
      ...offerWithoutScope,
      selection_id: selectionId,
      enabled: {
        ...offerWithoutScope.enabled,
        enabled,
      },
      author: {
        kind: 'user',
        id: userId,
      },
    };
  });
};

type BuildBatchEnableDisableOfferOverridesPayloadsArgs = {
  enabled: boolean;
  selectedIds: Set<string>;
  selectionOverrides?: SelectionOverridesResponse;
};

export const buildBatchEnableDisableOfferOverridesPayloads = ({
  enabled,
  selectedIds,
  selectionOverrides,
}: BuildBatchEnableDisableOfferOverridesPayloadsArgs): OfferingApiBatchUpdateOverridesPayload['offer_overrides_entries'] => {
  return [...selectedIds].map(offerId => {
    const maybeExistingOverrides: OfferOverrides = selectionOverrides?.offers?.[offerId] ?? {};
    return {
      offer_id: offerId,
      offer_overrides: {
        ...maybeExistingOverrides,
        enabled: { ...(maybeExistingOverrides.enabled ?? {}), enabled },
      },
    };
  });
};

export const buildResetOfferOverridesPayloads = (
  selectedIds: Set<string>,
): OfferingApiBatchUpdateOverridesPayload['offer_overrides_entries'] => {
  return [...selectedIds].map(offerId => {
    return {
      offer_id: offerId,
      offer_overrides: {},
    };
  });
};

export const buildBatchVatChangeOfferPayloads = (
  vatPayload: BatchUpdateVatPayload,
  offers: Offer[],
  selectionId: string,
  userId: string,
): OfferWithSelectionAndAuthor[] => {
  return offers.map(offer => {
    const { scope, ...offerWithoutScope } = offer;
    return {
      ...offerWithoutScope,
      ...vatPayload,
      selection_id: selectionId,
      author: {
        kind: 'user',
        id: userId,
      },
    };
  });
};

export const buildUpdateOffersPayload = (
  offers: Offer[],
  selectionId: string,
  userId: string,
): OfferWithSelectionAndAuthor[] => {
  return offers.map(offer => {
    const { scope, ...offerWithoutScope } = offer;
    return {
      ...offerWithoutScope,
      selection_id: selectionId,
      author: {
        kind: 'user',
        id: userId,
      },
    };
  });
};

export const buildBatchUpdatePayload = (
  offerPayloads: OfferWithSelectionAndAuthor[],
  entityScope: OfferingPlatformScope,
): OfferingApiUpdateOffersPayload => {
  return {
    offers: offerPayloads,
    request_scope: entityScope,
  };
};
